import { IdentityBodyAssessMeasurement } from '@reg/shared/model';

/**
 * Model to hold a body assessment reading taken by an assessor
 */
export class IdentityBodyAssessReading {
    public id: string = null;
    public value: string = null;
    public sequence: number = null;
    public bodyAssessmentId: string = null;
    public measurement: IdentityBodyAssessMeasurement;

    public isNew(): boolean {
        return (!this.id || this.id.indexOf('new_') >= 0);
    }

    public clone(): IdentityBodyAssessReading {
        const clone: IdentityBodyAssessReading = new IdentityBodyAssessReading();
        clone.id = this.id;
        clone.value = this.value;
        clone.sequence = this.sequence;
        clone.bodyAssessmentId = this.bodyAssessmentId;

        if (this.measurement) {
            clone.measurement = this.measurement.clone();
        }

        return clone;
    }

    /**
     * Serialize to a json api format
     * @returns {string}
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'bodyAssessmentReading';
        json.data.attributes = {};
        json.data.relationships = {};

        if (!this.isNew()) {
            json.data.id = this.id;
        }

        json.data.attributes.value = this.value;
        json.data.attributes.sequence = this.sequence;

        if (this.measurement) {
            const measurement: any = {};
            measurement.data = { type: 'bodyAssessmentMeasurement', id: this.measurement.id };
            json.data.relationships.bodyAssessmentMeasurement = measurement;
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: Object, included: Object[] = null): IdentityBodyAssessReading {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        included = included || json['included'];
        const relationships: Object[] = data['relationships'] || [];

        this.id = data['id'];
        this.value = attrs['value'];
        this.sequence = attrs['sequence'];
        this.bodyAssessmentId = attrs['bodyAssessmentId'];

        const measurementLink: Object = relationships['bodyAssessmentMeasurement'];
        if (measurementLink &&
            included &&
            measurementLink['data'] &&
            measurementLink['data']['id']) {
            const measurementId: string = measurementLink['data']['id'];
            const measurements: Object[] =
                included.filter((i: Object) => i['type'] === 'measurement' && i['id'] === measurementId);

            if (measurements.length === 1) {
                this.measurement = (new IdentityBodyAssessMeasurement()).deserialize(measurements[0], included);
            }
        } else if (attrs['bodyAssessmentMeasurementId']) {
            this.measurement = new IdentityBodyAssessMeasurement();
            this.measurement.id = attrs['bodyAssessmentMeasurementId'];
        }

        return this;
    }
}
